__turbopack_context__.v({
  "logo": "CembraSentence-module-scss-module__nz0UhW__logo",
  "prefix": "CembraSentence-module-scss-module__nz0UhW__prefix",
  "row": "CembraSentence-module-scss-module__nz0UhW__row",
  "wrapper": "CembraSentence-module-scss-module__nz0UhW__wrapper",
});
